import { useEffect } from 'react';

import { Container } from './header.style';

const HEADER_CONTAINER_ID = 'olist-header-component';
const SNIPPET_URL = process.env.REACT_APP_SHAPESHIFTER_SNIPPET_URL;

const LazyHeader = () => {
  useEffect(() => {
    if (!document.getElementById('shapeshifter-script')) {
      const script = document.createElement('script');
      script.src = SNIPPET_URL;
      script.async = true;
      script.defer = true;

      script.setAttribute('component-name', 'HeaderWebapp');
      script.setAttribute('component-context', 'store');
      script.setAttribute('container-id', HEADER_CONTAINER_ID);
      script.setAttribute('id', 'shapeshifter-script');

      document.body.appendChild(script);
    }
  }, []);

  return (
    <Container>
      <div id={HEADER_CONTAINER_ID} />
    </Container>
  );
};

export default LazyHeader;
